import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/rotate.svg'


const _withScopeId = n => (_pushScopeId("data-v-795525e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "banner-container"
}
const _hoisted_2 = {
  key: 0,
  class: "banner-box"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" We use 🍪 for more details check our ")
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "banner-box"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please enable notifications in your browser.", -1))
const _hoisted_7 = {
  key: 0,
  class: "page-rotate"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bitte verwenden Sie die Applikation im Portrait-Mode", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.path
    })),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.showBanner || _ctx.isNotificationMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.showBanner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("p", null, [
                      _hoisted_3,
                      _createElementVNode("a", {
                        href: _ctx.$t('pages.maps.user_settings.privacy.url'),
                        target: "_blank"
                      }, _toDisplayString(_ctx.$t('pages.maps.user_settings.privacy.label')), 9, _hoisted_4)
                    ]),
                    _createElementVNode("button", {
                      class: "button accept-btn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.okBannerClicked && _ctx.okBannerClicked(...args)))
                    }, "OK")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNotificationMessage && _ctx.isAllowedSubscriptions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("button", {
                      class: "button accept-btn",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeNotificationMessage && _ctx.closeNotificationMessage(...args)))
                    }, "Hide message")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isOs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
      : _createCommentVNode("", true)
  ], 64))
}